import React, { cloneElement, isValidElement, memo } from 'react';
import { useDispatch } from 'react-redux';
import { notifyRequestResult } from '../store/modules/notify';

export const CopyPathToClipboard = memo(
  ({
     text = '',
     message = 'copied',
     children,
   }: {
    text?: string;
    message?: string;
    children?: React.ReactNode;
  }) => {
    const dispatch = useDispatch();

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(text);
        dispatch(
          notifyRequestResult(message, 'success', { autoHideDuration: 750 }),
        );
      } catch {
        dispatch(
          notifyRequestResult('Copy failed', 'error', { autoHideDuration: 750 }),
        );
      }
    };

    if (isValidElement(children)) {
      const originalOnClick = (children as React.ReactElement<any>).props.onClick;
      const combinedOnClick = (e: React.MouseEvent) => {
        if (originalOnClick) {
          originalOnClick(e);
        }
        handleCopy();
      };

      return cloneElement(children, {
        // @ts-ignore
        onClick: (children as React.ReactElement<any>).props.onClick ? combinedOnClick : handleCopy,
        style: { cursor: 'pointer', ...((children as React.ReactElement<any>).props.style || {}) },
      });
    }

    return (
      <div onClick={handleCopy} style={{ cursor: 'pointer' }}>
        {children}
      </div>
    );
  },
);

export default CopyPathToClipboard;
